import React from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getData } from "../../../utils/storage";
import { calculateLoanFormula } from "../../../utils/loancal";

function Seller({ title, plates, plate }) {
  console.log(plates);
  const navigate = useNavigate();
  const resBuyline = useSelector((s) => s.buyline.data.enable);
  const isBuylineEnable = resBuyline;
  return (
    <>
      <div className="premium-registrations">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="premium-title">
                <img crossOrigin="anonymous" src="/img/vip-crown-fill.png" />
                <h2>{title}</h2>
              </div>
            </div>
          </div>
          <div className="premium-table">
            <div className="premium-table-head">
              <ul>
                <li>
                  <h2>initials</h2>
                </li>
                <li>
                  <h2>Price</h2>
                </li>
                <li>
                  <h2>Action</h2>
                </li>
              </ul>
            </div>
            <div className="premium-table-body">
              {plates?.length > 0
                ? plates.map((p) => (
                    <ul
                      key={p.fullNumber}
                      onClick={() => navigate(`/view-premium/${p.fullNumber}`)}
                    >
                      <li>
                        <div className="nik-button">
                          <button type="button" className="btn btn-warning">
                            {p.fullNumber?.toUpperCase()}
                          </button>
                        </div>
                      </li>
                      <li>
                        <h3>£{p.price}</h3>
                      </li>
                      {isBuylineEnable && parseFloat(p.price) > 250 && (
                        <li>
                          <div className="finance-register">
                            <img src="/img/flower-logo.png" />
                            <h6>
                              Finance Available From £
                              {calculateLoanFormula(p?.price, 48).toFixed(2)}{" "}
                              per month
                            </h6>
                          </div>
                        </li>
                      )}
                      <li>
                        <div className="view-button">
                          {isBuylineEnable && parseFloat(p.price) > 250 && (
                            <button
                              type="button"
                              onClick={() =>
                                navigate(`/view-premium/${p.fullNumber}`)
                              }
                              className="btn btn-warning"
                            >
                              Buy With Finance
                            </button>
                          )}
                          <Link
                            to={`/view-premium/${p.fullNumber}`}
                            className="red-link"
                          >
                            <button type="button" className="btn btn-warning">
                              View Plate
                            </button>
                          </Link>
                        </div>
                      </li>
                    </ul>
                  ))
                : null}
            </div>
          </div>
          {plates.length >= 10 && (
            <div className="col-md-12">
              <div className="row mb-5">
                <div className="col-4"></div>
                <div className="view-more-button">
                  <button
                    className="btn btn-dark"
                    // onClick={() => navigate(`/${page}/${plate}/1`)}
                  >
                    View More
                  </button>
                </div>
                <div className="col-4"></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Seller;
